import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasAccess } from '../services/authService';

const RoleBasedRoute = ({ children, allowedRoles = [] }) => {
  // Check if user is authenticated
  const isAuthenticated = Boolean(localStorage.getItem('adminToken'));
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Check if user has required role access
  if (allowedRoles.length > 0 && !hasAccess(allowedRoles)) {
    // Redirect to a default accessible page or show unauthorized message
    return <Navigate to="/events" replace />;
  }
  
  return children;
};

export default RoleBasedRoute;
